<app-progress-bar [isLoading]="isLoading"></app-progress-bar>
<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<!-- <mat-accordion>
  <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
    <mat-expansion-panel-header class="ia-mat-panel">
      <mat-panel-title>
        <span class="text-header f-18">
          Summary Details
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row mr-0 ml-0" *ngIf="impactAssessment.isMerged">
      <span class="ml-4 mr-3"><label class="control-label fw inline-block">Assessment Id </label></span>
      <a>
        <span *ngFor="let item of impactAssessment.merged_Id|stringToArray;" (click)="getUpdatedDbInfo(item)">
          <span
            [ngClass]="this.impactAssessment.updatedDB_Id == item ?  'parent-id':'link-id d-inline-block'">{{item}}<span
              class="cursor-pointer ml-1"
              *ngIf="this.impactAssessment.updatedDB_Id != item && (currentUserRole === 'Compliance Enterprise' || isSavedPermission)"></span></span>
        </span>
      </a>
      <span class="parent-span">
        <label class="control-label fw mr-2 inline-block"> Parent Id </label>
        <span *ngIf="!isParentIdEdit" class="control-label inline-block">{{impactAssessment.updatedDB_Id}}</span>
        <span *ngIf="isParentIdEdit" class="inline-block">
          <select class="form-control form-control-sm" [(ngModel)]="parentId">
            <option *ngFor="let item of impactAssessment.merged_Id|stringToArray;" value="{{item}}">{{item}}
            </option>
          </select>
        </span>
      </span>
    </div>
    <div class="row form-group ml-2 mt-1 div-scroll">
      <div class="col-lg-2 col-md-1 mx-width-10pr">
        <label class="control-label fw"> {{ impactAssessment.isMerged? "Id":"Assessment Id" }}</label>
        <div class="control-label" name="ids">{{ this.currentinfoId }}</div>
      </div>
      <div class="col-lg-5 col-md-5 mx-width-40pr">
        <label class="control-label fw">Title</label>
        <div class="pt-2 control-label div-scroll" name="title">{{ impactAssessment.title }}</div>
      </div>
      <div class="col-lg-1 mx-width-14pr">
        <label class="control-label fw">Type</label>
        <div class="pt-2 control-label" name="title">{{ impactAssessment.pubType }}</div>
      </div>
      <div class="col-lg-1 mx-width-10pr">
        <label class="control-label fw">Geography</label>
        <div class="pt-2 control-label">{{impactAssessment.geography}}</div>
      </div>
      <div class="col-lg-1 mx-width-10pr">
        <label class="control-label fw">Country</label>
        <div class="pt-2 control-label">{{impactAssessment.country}}</div>
      </div>
      <div class="col-lg-1 mx-width-8pr">
        <label class="control-label fw">Regulator</label>
        <div class="pt-2 control-label">{{impactAssessment.regulator}}</div>
      </div>
      <div class="col-lg-2 mx-width-8pr">
        <label class="control-label fw">Date</label>
        <div class="pt-2 control-label">{{impactAssessment.updatedDB_Date | date: 'dd-MMM-yyyy' }}</div>
      </div>
    </div>
    <div class="row ml-2">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-9 fw">
            <label class="control-label fw">Description</label>
          </div>
          <div class="col-lg-3" *ngIf="impactAssessment.hyperlink">
            <a href="{{impactAssessment.hyperlink}}" class=" pull-right" target="_blank">
              <i class="fa fa-globe"></i>
              <span class="text-primary cursor-pointer">
                Source Link</span>
            </a>
          </div>
          <div class="col-lg-3" *ngIf="!impactAssessment.hyperlink">
            <span class="pull-right"><i class="fa fa-globe"></i><span> Source Link</span></span>
          </div>
          <div class="col-lg-12 edit_status_changeViewer_group  mt-1">
            <mat-form-field class="disableText w-100">
              <textarea matInput [(ngModel)]="impactAssessment.description" class="text-area-css" cdkTextareaAutosize
                disabled></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-lg-3 desc-text-box" *ngIf="currentinfoId > 0">
        <app-current-action [userId]="userAccessToken.userId" [itemId]="currentinfoId" [closedType]="'Assess'">
        </app-current-action>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<mat-accordion>
  <mat-expansion-panel [expanded]="false" class="ia-expansion-panel mt-2 pl-2">
    <mat-expansion-panel-header class="ia-mat-panel">
      <mat-panel-title>
        <span class="text-header f-18">
          Additional Details
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row ml-2 mt-1">
      <div class="col-lg-2">
        <label class="control-label fw">Division</label>
        <ng-select class="mt_custom" *ngIf="searchedJuris.length > 0" [items]="searchedJuris" bindLabel="name"
          appendTo="body" [multiple]="true" [(ngModel)]="selectedJuris" disabled>
        </ng-select>
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Legal Entity</label>
        <div class="pt-2">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.legalEntity" />
        </div>
      </div>

      <div class="col-lg-2">
        <label class="control-label fw">Rule Type</label>
        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ruleType" style="margin-top:7px">
          <option *ngFor="let option of ruleType" value="{{option}}">{{option}}</option>
        </select>
      </div>
      <div class="col-lg-2">
        <label class="control-label fw">Effective Date</label>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="picker" (click)="picker.open()" style="margin-top:8px"
            class="form-control form-control-sm border-bottom" name="applicationDate"
            [(ngModel)]="impactAssessment.applicationDate">
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" style="margin-top:8px" (click)="picker.open()"></span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="col-lg-2">
        <button class="btn bg-g-lightGreen btn-sm" style="cursor:initial">Linked Assessments</button>
        <div class="mt-1" *ngIf="impactAssessment.previousImpactAsss_Id">
          <div class="link-div mb-1" *ngFor="let linkedAId of linkedAssessmentIds">
            <a href="/impact-assessment/details/impact/{{linkedAId.id}}" class="link-id ">{{linkedAId.updatedDbId}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-1">
        <div>
          <label class="control-label mx-auto fw">Topic</label>
        </div>
      </div>
      <div class="col-lg-11 topic-list">
       
        <mat-chip-grid #topicList class="myChip">
          <ng-container *ngFor="let item of this.impactAssessment.ruleTopic">
            <mat-chip-row [style.background-color]="item[0]" *ngFor="let TopicItemName of sortArray(item[1])">
              <span [style.color]="getContrastYIQ(item[0])">{{TopicItemName}}</span>
            </mat-chip-row>
          </ng-container>
        </mat-chip-grid>

      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion> -->
<div class="row mt-3">
  <div class="col-lg-6">
    <div class="text-header f-18">
      Impact Assessment Calculation
    </div>
    <div *ngIf="ratingDetails && ratingDetails.length > 0">
      <mat-accordion *ngFor="let ratingInfo of ratingDetails">
        <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2">
          <mat-expansion-panel-header class="ia-mat-panel required-span">
            <mat-panel-title>
              <span class="f-18 text-header"> {{ ratingInfo.title }}</span>
            </mat-panel-title>
            <mat-panel-description class="required-text">
              <span class="text-header " [ngClass]="ratingInfo.color" *ngIf="ratingInfo.isRequired"> Required</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row box-shadow p13-0 m-0" *ngIf="ratingInfo.rating === -1">
            <div class="col-md-9 text-font">{{ ratingInfo.subTitle }}</div>
            <div class="col-md-3 text-center">
              <select class="form-control text-font"
                (change)="addImpactOutcomes(ratingInfo.selectedId, ratingInfo.childItems)"
                [(ngModel)]="ratingInfo.selectedId" [attr.disabled]="isActiveBtn ? isActiveBtn : null">
                <option value="-1">Select</option>
                <option title="{{ child.guidance }}" *ngFor="let child of ratingInfo.childItems" [value]="child.id">
                  {{ child.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="row box-shadow p13-0 m-0" *ngIf="ratingInfo.rating === -2">
            <div class="col-md-10 text-font">{{ ratingInfo.subTitle }}</div>
            <div class="col-md-2 text-center text-font">Select</div>
          </div>
          <ng-container *ngIf="ratingInfo.rating === -2">
            <div class="row rw-div p13-0 m-0" *ngFor="let child of ratingInfo.childItems">
              <div class="col-md-10">
                <span class="text-font">{{ child.title }}</span>
              </div>
              <div class="col-md-2 text-center">
                <input type="radio" (change)="getImpactOutComeRating($event, child.parentId, child.id)"
                  [attr.disabled]="isActiveBtn ? isActiveBtn : null" [value]="child.rating"
                  [checked]="checkIfExist(child.parentId, child.id)" [attr.name]="child.subTitle" />
              </div>
            </div>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="col-lg-6">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-4">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="f-18 fg-color">Summary Impact Outcome</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
        <table class="table table-hover" *ngIf="impactOutcomeResult && impactOutcomeResult.length > 0">
          <tbody>
            <ng-container *ngFor="let item of impactOutcomeResult">
              <tr>
                <td class="text-font">{{item.title}}</td>
                <td class="text-center bg-red f-16" *ngIf="item.impactValue === 'Very High'" style="width:20%">
                  {{item.impactValue}}</td>
                <td class="text-center bg-orange f-16" *ngIf="item.impactValue === 'High'" style="width:20%">
                  {{item.impactValue}}</td>
                <td class="text-center bg-yellow f-16" *ngIf="item.impactValue === 'Medium'" style="width:20%">
                  {{item.impactValue}}</td>
                <td class="text-center bg-green f-16" *ngIf="item.impactValue === 'Low'" style="width:20%">
                  {{item.impactValue}}</td>
                <td class="text-center bg-green f-16" *ngIf="item.impactValue === 'Very Low'" style="width:20%">
                  {{item.impactValue}}</td>
                <td class="text-center f-16" *ngIf="item.impactValue === 'None' || item.impactValue === 'Unknown'"
                  style="width:20%">{{item.impactValue}}</td>
              </tr>
            </ng-container>
            <tr>
              <td class="result-outcome">Overall Impact Outcome</td>
              <td class="text-center f-16"
                [ngClass]="resultRating === 'Very High' ? 'bg-red' : resultRating === 'High' ? 'bg-orange': resultRating === 'Medium' ? 'bg-yellow': resultRating === 'Low' ? 'bg-green': resultRating === 'Very Low' ? 'bg-green' : null"
                style="width:20%">{{resultRating}}</td>
            </tr>
          </tbody>
        </table>
      </mat-expansion-panel>
      <div class="text-right mt-3">
      </div>
    </mat-accordion>
  </div>
</div>